export enum FileCategoryEnum {
 Site = 'Site',
 Blast = 'Blast',
 Project = 'Project',
 Workflow = 'Workflow',
 Other = 'Other'
}